// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"Wu99WKfkeoLeBytZbXmi","tooltipText":"QU1vF2VbVB9dyvH7D_Kw","sidebarContainer":"djqgXexI1bhBNCu506FO","sidebarLogo":"lnvptKrIAowCWreuyg5i"};